/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class BannerSubtitleContent extends Component {
	view() {
		return <h3 className={this.attrs.className}>{m.trust(this.attrs.deviceData)}</h3>;
	}
}

export default class BannerSubtitle extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.subtitle;
	}

	getClassName() {
		return `${super.className} BannerSubtitle`;
	}

	get content() {
		return BannerSubtitleContent;
	}
}
